import React, { useEffect, useState } from "react";
import './SubordinatePlans.css'
import TauriImage from "../../TauriImage/TauriImage";
import appURL from '../../../appURL.json';
import TauriLoader2 from "../../TauriLoader2/TauriLoader2";
import OpalAlertModal from "../../OpalAlertModal/OpalAlertModal";
import { transformWorksheets } from "../PlanningFactoryData/PlanningFactoryData";
import { planStatusDisplayNames } from "../../../visualizations/visualizations";
import { useNavigate } from "react-router-dom";

const SubordinatePlans = ({ statusColors }) => {
    const [search, setSearch] = useState('');
    const [itemList, setItemList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showAlertModal, setShowAlertModal] = useState(false);
    const [alertModalProps, setAlertModalProps] = useState({
        title: "",
        bodyText: "",
        confirmButtonText: "",
        cancelButtonText: "",
        Icon: "",
        modalType: ""
    });

    const storedPermission = localStorage.getItem("permission");
    const permission = JSON.parse(atob(storedPermission));

    const navigate = useNavigate();

    const fetchOnlineApprovableWorksheet = async () => {
        try {
            setLoading(true);

            const c_id = localStorage.getItem("c_id");
            const token = localStorage.getItem("token");
            const devId = localStorage.getItem("devId");
            const response = await fetch(`${appURL.API_Worksheet}/subordinates/${Number(permission?.coverage?.employee_id)}/${c_id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'X-ETR-Device-ID': devId
                }
            });

            if (!response.ok) {
                setAlertModalProps({
                    title: "Failed",
                    bodyText: "Failed to load subordinate plan",
                    confirmButtonText: "",
                    cancelButtonText: "Ok",
                    Icon: "",
                    modalType: "message"
                });

                setShowAlertModal(true);
                return;
            }

            const data = await response.json();
            const tranformWorksheets = await transformWorksheets(data.worksheets);
            setItemList(tranformWorksheets);
        } catch (err) {
            setAlertModalProps({
                title: "Failed",
                bodyText: "Failed to load subordinate plan",
                confirmButtonText: "",
                cancelButtonText: "Ok",
                Icon: "",
                modalType: "message"
            });

            setShowAlertModal(true);
        } finally {
            setLoading(false);
        }
    }

    const fetchData = async () => {
        const isOnline = JSON.parse(localStorage.getItem("isOnline"));
        const hasInternet = navigator.onLine;

        if (isOnline && hasInternet) {
            await fetchOnlineApprovableWorksheet();
        }
    }

    useEffect(() => {
        fetchData();
    }, [])

    useEffect(() => {
        if (!search) {
            setFilteredList(itemList);
        } else {
            const lowerSearch = search.toLowerCase();

            const filtered = itemList.filter(item => {
                const planNoMatch = item?.PlanNumber?.toLowerCase().includes(lowerSearch);
                const empMatch = item?.EmployeeName?.toLowerCase().includes(lowerSearch);
                const codeMatch = item.Cycle?.Code?.toLowerCase().includes(lowerSearch);
                const descMatch = item.Cycle?.Description?.toLowerCase().includes(lowerSearch);
                return planNoMatch || empMatch || codeMatch || descMatch;
            });

            setFilteredList(filtered);
        }
    }, [search, itemList]);


    const handleRowClick = (id) => {
        navigate(`/planning/${id}`);
    }

    return (
        <div className="opal-subordinate-plans w-100">
            <div className="filter-section d-flex align-items-center justify-content-end mb-2">
                <div className="search-section d-flex align-items-center p-2">
                    <TauriImage
                        localImage={"/Images/symbols--search.svg"}
                        alt="icon"
                        color={"#7FA6D3"}
                    />
                    <div className="input-group">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Type to Search"
                            autoComplete="new-password"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>
                </div>
            </div>
            <div className="subordinate-list-table">
                {loading ? (
                    <TauriLoader2 width="2.5rem" height="2.5rem" borderwidth="0.35rem" color="#1D5D9B" />
                ) : (
                    <table className="table w-100 border-collapse">
                        <thead className="subordinate-list-table-header">
                            <tr>
                                <th>PLAN NO.</th>
                                <th>EMPLOYEE NAME</th>
                                <th>CYCLE PERIOD</th>
                                <th>RANGE</th>
                                <th>STATUS</th>
                            </tr>
                        </thead>
                        <tbody className="subordinate-list-table-body">
                            {filteredList.map((row, idx) => (
                                <tr
                                    key={row.ID}
                                    className={idx % 2 === 0 ? "" : "even"}
                                    onClick={() => handleRowClick(row.ID)}
                                    style={{ cursor: "pointer" }}
                                >
                                    <td>{row?.PlanNumber}</td>
                                    <td>{row?.EmployeeName}</td>
                                    <td>{row?.Cycle?.Code}</td>
                                    <td>{row?.Cycle?.Description}</td>
                                    <td style={{ color: statusColors[row.Status] }}>{planStatusDisplayNames[row.Status]}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
            <OpalAlertModal
                show={showAlertModal}
                onHide={() => setShowAlertModal(false)}
                title={alertModalProps.title}
                bodyText={alertModalProps.bodyText}
                confirmButtonText={alertModalProps.confirmButtonText}
                cancelButtonText={alertModalProps.cancelButtonText}
                modalType={alertModalProps.modalType}
                Icon={alertModalProps.Icon}
            />
        </div>
    );
};

export default SubordinatePlans;
